import { render, staticRenderFns } from "./PlayerDiplomacyStatusChanged.vue?vue&type=template&id=664add26&scoped=true&"
import script from "./PlayerDiplomacyStatusChanged.vue?vue&type=script&lang=js&"
export * from "./PlayerDiplomacyStatusChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664add26",
  null
  
)

export default component.exports